var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppBridge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "#000B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.397 14.4297H22.0894C27.936 14.4297 30.8223 17.427 30.8223 20.9792C30.8223 23.3843 30.0083 25.1235 28.0103 26.1965C30.23 27.1216 31.6362 28.7866 31.6733 31.562C31.7105 36.0393 28.084 39.2214 21.2388 39.2214H10.397V14.4297ZM21.3125 24.1614C22.9409 24.1614 23.9399 23.4583 23.9399 22.0151C23.9399 20.6831 23.0884 19.906 21.2388 19.906H17.2422V24.1614H21.3125ZM21.4233 33.7451C23.1997 33.7451 24.5689 33.0791 24.5689 31.377C24.5689 30.0078 23.7549 29.0828 21.6455 29.0828H17.2422V33.7451H21.4233Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3096 19.573C43.8267 19.573 45.0479 19.7581 45.603 19.9431V24.9753C45.1587 24.8645 44.3081 24.7905 43.605 24.7905C42.2358 24.7905 41.4585 24.9014 40.7554 25.1604V39.2214H34.2798V21.2012C36.6113 20.1651 38.9424 19.573 42.3096 19.573Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppBridge);
export default __webpack_public_path__ + "static/media/B_app_Bridge.f929bce04776866f81253d2f96319188.svg";
export { ForwardRef as ReactComponent };